angular.module('bmsApp.crm.email', [])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.crm.customer.index.emailView', {
					url: '^/email/{emailId:int}',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/email/templates/EmailView.html",
							controller: 'EmailViewCtrl'
						}
					},
					ncyBreadcrumb: {label: '{{ emailViewCtrl.email.subject }}'}
				})

			;

		}]);
